export default __webpack_public_path__ + "img/f39aff3ddf5272cf4edce911ac03d0b8.svg";